<mat-dialog-content [class]="dialogContentClass">
    <!-- <div style="right:65px; position:absolute;" *ngIf="!dialogRef.disableClose">
        <button mat-icon-button style="position: relative; left: 97%; top: -10px;" (click)="dialogRef.close({data:'',clickAction:'close'});"><mat-icon>close</mat-icon></button>
    </div> -->

    <div class="dialogToTopButton">
        <button mat-fab (click)="scrollToTop()" [disabled]="!navToTop" [matTooltipPosition]="'left'" matTooltip="Return to top">
          <mat-icon>vertical_align_top</mat-icon>
        </button>
    </div>

    <button mat-icon-button style="right:24px; top:-12px; position:absolute;" (click)="closeDialog()"><mat-icon>close</mat-icon></button>
    <div style="height: 20px;">

    </div>
    <div [class]="templateContentClass" [id]="containerId">
        <!-- <div style="height: 25px;">

        </div> -->
        <ng-template #target></ng-template>
    </div>
</mat-dialog-content>